import { openDB } from "idb";

export const openIdb = (dbName, storeName, dbVersion, calenderKey) => {
  const dbPromise = openDB(dbName, dbVersion, {
    upgrade(db) {
      db.createObjectStore(storeName);
    },
  });

  return {
    get: async function (key) {
      let cacheData = await (await dbPromise).get(
        storeName,
        key + "_" + calenderKey
      );
      if (
        typeof cacheData != "undefined" &&
        typeof cacheData.createDate != "undefined"
      ) {
        if (DidTimeExpired(cacheData.createDate) === false) {
          return cacheData.value;
        } else {
          (await dbPromise).delete(storeName, key + "_" + calenderKey);
          return null;
        }
      }
    },
    set: async function (key, value) {
      let currentDate = new Date();
      return (await dbPromise).put(
        storeName,
        {
          value: value,
          createDate:
            currentDate.getFullYear() +
            "_" +
            currentDate.getMonth() +
            "_" +
            currentDate.getDate() +
            "_" +
            currentDate.getHours() +
            "_" +
            currentDate.getMinutes() +
            "_" +
            currentDate.getSeconds(),
        },
        key + "_" + calenderKey
      );
    },
    del: async function (key) {
      return (await dbPromise).delete(storeName, key + "_" + calenderKey);
    },
    clear: async function () {
      return (await dbPromise).clear(storeName);
    },
    keys: async function () {
      return (await dbPromise).getAllKeys(storeName);
    },
  };
};

export function DidTimeExpired(date) {
  const givendate = date.split("_");
  const currentDate = new Date();
  const msInSecond = 1000; //1000;

  let startDate = new Date(
    givendate[0],
    givendate[1],
    givendate[2],
    givendate[3],
    givendate[4],
    givendate[5]
  );
  let endDate = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    currentDate.getDate(),
    currentDate.getHours(),
    currentDate.getMinutes(),
    currentDate.getSeconds()
  );
  return Math.round(Math.abs(endDate - startDate) / msInSecond) > 60;
}
